import { type DevicesModel } from '../models/DeviceModel';

export const devices: DevicesModel = {
    mobile: { min: 0, max: 767 },
    tablet: { min: 768, max: 991 },
    laptop: { min: 992, max: 1199 },
    computer: { min: 1200, max: 1359 },
    widescreen: { min: 1360 }
};
